import React from "react";

export const MoreDots = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>more-dots</title>
    <g
      id="more-dots"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M6,10 C4.9,10 4,10.9 4,12 C4,13.1 4.9,14 6,14 C7.1,14 8,13.1 8,12 C8,10.9 7.1,10 6,10 Z M18,10 C16.9,10 16,10.9 16,12 C16,13.1 16.9,14 18,14 C19.1,14 20,13.1 20,12 C20,10.9 19.1,10 18,10 Z M12,10 C10.9,10 10,10.9 10,12 C10,13.1 10.9,14 12,14 C13.1,14 14,13.1 14,12 C14,10.9 13.1,10 12,10 Z"
        id="dots"
        fill="#6E7A8A"
        fill-rule="nonzero"
      ></path>
    </g>
  </svg>
);

export const SortArrows = () => (
  <svg
    width="10px"
    height="10px"
    viewBox="0 0 10 10"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>sort-arrows</title>
    <g
      id="sort-arrows"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <polygon id="arrow-down" fill="#A0ADBA" points="5 10 2 6 8 6"></polygon>
      <polygon id="arrow-up" fill="#A0ADBA" points="2 4 8 4 5 0"></polygon>
    </g>
  </svg>
);

export const Edit = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="edit" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <path
        d="M1,11.8875 L1,15.0075 L4.12,15.0075 L13,6.1275 L9.88,3.0075 L1,11.8875 Z M15.76,3.3775 C16.09,3.0475 16.09,2.5275 15.76,2.1975 L13.81,0.2475 C13.48,-0.0825 12.96,-0.0825 12.63,0.2475 L11,1.8875 L14.12,5.0075 L15.76,3.3775 L15.76,3.3775 Z"
        id="pencil"
        fill="#6E7A8A"
        fill-rule="nonzero"
      ></path>
    </g>
  </svg>
);

export const ArrowDown = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="icon/16/arrow-down"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M7.29289,11.7071 C7.68342,12.0976 8.31658,12.0976 8.70711,11.7071 L13.7071,6.70711 C14.0976,6.31658 14.0976,5.68342 13.7071,5.29289 C13.3166,4.90237 12.6834,4.90237 12.2929,5.29289 L8,9.58579 L3.70711,5.29289 C3.31658,4.90237 2.68342,4.90237 2.29289,5.29289 C1.90237,5.68342 1.90237,6.31658 2.29289,6.70711 L7.29289,11.7071 Z"
        id="arrow-down"
        fill="#4A5768"
      ></path>
    </g>
  </svg>
);

export const DragHandle = () => (
  <svg
    width="16px"
    height="24px"
    viewBox="0 0 16 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="drag-handle"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M5.5,15 C6.32842712,15 7,15.6715729 7,16.5 C7,17.3284271 6.32842712,18 5.5,18 C4.67157288,18 4,17.3284271 4,16.5 C4,15.6715729 4.67157288,15 5.5,15 Z M10.5,15 C11.3284271,15 12,15.6715729 12,16.5 C12,17.3284271 11.3284271,18 10.5,18 C9.67157288,18 9,17.3284271 9,16.5 C9,15.6715729 9.67157288,15 10.5,15 Z M10.5,10 C11.3284271,10 12,10.6715729 12,11.5 C12,12.3284271 11.3284271,13 10.5,13 C9.67157288,13 9,12.3284271 9,11.5 C9,10.6715729 9.67157288,10 10.5,10 Z M5.5,10 C6.32842712,10 7,10.6715729 7,11.5 C7,12.3284271 6.32842712,13 5.5,13 C4.67157288,13 4,12.3284271 4,11.5 C4,10.6715729 4.67157288,10 5.5,10 Z M5.5,5 C6.32842712,5 7,5.67157288 7,6.5 C7,7.32842712 6.32842712,8 5.5,8 C4.67157288,8 4,7.32842712 4,6.5 C4,5.67157288 4.67157288,5 5.5,5 Z M10.5,5 C11.3284271,5 12,5.67157288 12,6.5 C12,7.32842712 11.3284271,8 10.5,8 C9.67157288,8 9,7.32842712 9,6.5 C9,5.67157288 9.67157288,5 10.5,5 Z"
        fill="#A0ADBA"
      ></path>
    </g>
  </svg>
);

export const Search = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <path
      fill="#A0ADBA"
      d="M4.5,0 C6.98528137,0 9,2.01471863 9,4.5 C9,5.38015953 8.74731116,6.20130042 8.31052156,6.89483459 L11.7071068,10.2928932 L10.2928932,11.7071068 L6.89483459,8.31052156 C6.20130042,8.74731116 5.38015953,9 4.5,9 C2.01471863,9 0,6.98528137 0,4.5 C0,2.01471863 2.01471863,0 4.5,0 Z M4.5,2 C3.11928813,2 2,3.11928813 2,4.5 C2,5.88071187 3.11928813,7 4.5,7 C5.88071187,7 7,5.88071187 7,4.5 C7,3.11928813 5.88071187,2 4.5,2 Z"
    />
  </svg>
);
